const INVITATION_TOKEN_PARAM = 'invitation_token';

let invitationToken: string | undefined;

// GA・Datadog RUM・Sentry が URL を読む前（各 SDK の初期化より先）に呼ぶ。
// 以降はメモリ上の値を使い、URL や history.state には戻さない
export const takeInvitationTokenFromUrl = (): void => {
  const url = new URL(window.location.href);
  invitationToken = url.searchParams.get(INVITATION_TOKEN_PARAM) ?? undefined;
  if (!invitationToken) return;

  url.searchParams.delete(INVITATION_TOKEN_PARAM);
  window.history.replaceState(
    window.history.state,
    '',
    `${url.pathname}${url.search}${url.hash}`,
  );
};

export const getInvitationToken = (): string | undefined => invitationToken;

export const setInvitationToken = (token: string | undefined): void => {
  invitationToken = token;
};
